import { Theme } from "@material-ui/core";
import { UserStatus } from "Shared/types/EmployeeProfiles";
import colors from "Styles/colors";

export function userStatusToColor(userStatus: UserStatus, theme: Theme) {
  switch (userStatus) {
  case UserStatus.ACTIVE:
    return theme.palette.success.main;
  case UserStatus.PENDING:
    return colors.black;
  case UserStatus.REVIEW:
    return colors.tahitiGold;
  case UserStatus.CANCELED:
    return theme.palette.error.main;
  }
}
